import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
var LSCMSUtils = {
  popup: null,
  cookieConsentPages: ['home', 'product', 'blog', 'search', 'profile'],
  pendingOrderPages: ['home', 'product', 'search'],
  captchaPages: ['search', 'checkout'],
  initialize: function initialize() {
    if (window.utilAlreadyRun) return;
    // backward compatibility
    clientData.page = clientData.page ? clientData.page : clientData.pageJson;
    //console.log('utils init')
    var location = this.getLocationClean();
    if (this.shouldShowCookieConsent()) this.showCookieConsent();
    if (this.shouldShowPendingOrder()) this.showPendingOrder();
    if (this.shouldPreOpenZendeskWidget()) this.preOpenZendeskWidget();

    // this.loadGtm();
    if (!location.includes('/checkout') && !location.includes('/status') && !location.includes('/form')) {
      if (window.location.pathname === "/" || window.location.pathname === "/legalstart/") {
        this.gtmPageViewEvent('/home');
      } else {
        this.gtmPageViewEvent(location);
      }
    }
    this.loadTPWidget();
    this.bindFAQSection();
    this.initPopovers();
    window.utilAlreadyRun = true;
  },
  // COOKIE

  shouldShowCookieConsent: function shouldShowCookieConsent() {
    if (this.cookieConsentPages.includes(clientData.page.type)) {
      var cookie = Cookies.getJSON('of-cookie-consent');
      return !cookie || !cookie.all;
    }
    return false;
  },
  showCookieConsent: function showCookieConsent() {
    var self = this;
    var isRegistered = false;
    var registered = function registered() {
      if (!isRegistered) {
        isRegistered = true;
        console.log('callback showCookieConsent');
        setTimeout(function () {
          $('#container-cookie-consent').show();
        }, 250);
        $('.btn', $('#container-cookie-consent')).bind('click', function () {
          if (window.dataLayer && typeof gtag !== 'undefined') gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
          });
          self.onCookieConsentAccept();
          return false;
        });
      }
    };
    LSUtils.registerEventOnUserInteraction(function () {
      registered();
    });
  },
  onCookieConsentAccept: function onCookieConsentAccept() {
    $('#container-cookie-consent').hide();
    Cookies.set('of-cookie-consent', {
      all: true
    });
  },
  saveEmail: function saveEmail(email) {
    var dfd = $.Deferred();
    if (!clientData.emails) clientData.emails = {};
    clientData.emails.contact = email;
    clientData.emails.contactSavedOn = window.location.pathname;
    if (clientData.page.type === 'checkout') $('[name="email"]').val(email);
    $.ajax({
      url: LSUtils.url() + '/app/services/customer?clientId=' + clientData.clientId,
      type: 'POST',
      data: {
        'emails.contact': clientData.emails.contact,
        'emails.contactSavedOn': clientData.emails.contactSavedOn
      },
      success: function success() {
        dfd.resolve();
      }
    });
    return dfd.promise();
  },
  // trustpilot widget
  // delay for pagespeed perf
  loadTPWidget: function loadTPWidget() {
    setTimeout(function () {
      var tag = $('<script>');
      tag.attr('src', '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
      tag.prop('async');
      $('.reviews-section .trustpilot-widget').append(tag);
    }, 1000);
  },
  bindFAQSection: function bindFAQSection() {
    $('.faq .panel-card').click(function () {
      // Toggle the 'expanded' class on the clicked panel-card
      $(this).toggleClass('expanded');
      $(this).find('.panel-title').toggleClass('bold');
    });
  },
  /*
  * data example:
  * {
  *   'emails.contact': clientData.emails.contact,
  *   'emails.contactSavedOn': clientData.emails.contactSavedOn
  * }
  *
   */
  savePreCheckoutData: function savePreCheckoutData(data) {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/customer?clientId=' + clientData.clientId,
      type: 'POST',
      data: data,
      success: function success() {
        dfd.resolve();
      }
    });
    return dfd.promise();
  },
  // SEARCH NAME MODAL

  showNameSearchModal: function showNameSearchModal() {
    var _clientData$page, _clientData$page2;
    var dataRedirect = (_clientData$page = clientData.page) !== null && _clientData$page !== void 0 && _clientData$page.funnelNext ? 'data-redirect="' + ((_clientData$page2 = clientData.page) === null || _clientData$page2 === void 0 ? void 0 : _clientData$page2.funnelNext) + '"' : '';
    var $modal = $('<form class="form-ch-search-custom needs-validation" style="display: flex;flex-direction: column;margin: auto;" novalidate action="#">' + "<img src=\"".concat(LSUtils.url(), "/cms/data/content/common/img/logo_hd.png\" style=\"width: 32px; height: 32px;margin:auto;\" class=\"mb-2\"/><br/>") + '    <div class="my-4" style="max-width: 400px;margin: auto;">' + '    <p class="text-lg my-0 mb-3">' + '        To start your limited company registration, let\'s check your ideal company name availability.' + '    </p>' + '    <div class="form-group cta input-group" style="max-width: 400px;">' + '        <label class="text-lg" style="margin-top: 4px;line-height: 32px">' + '            Register a limited company now:' + '        </label>' + '        <input type="text" class="form-control" required name="company"' + '               placeholder="Ideal company name..."' + '               style="border-color: #28a745;border-width: 2px;max-width: 410px;border-top-left-radius: 8px;border-bottom-left-radius: 8px;height: 52px;"/>' + '        <div class="input-group-append">' + '            <button tabindex="-1" class="btn btn-outline-secondary dropdown-toggle text-sm name-ending-selected"' + '                    type="button"' + '                    style="min-width: 90px;padding: 0;margin-top: 7px;border: 2px solid #28a745!important;color: black;font-weight: normal;border-top-right-radius: 8px !important;border-bottom-right-radius: 8px !important;background-color: white !important;"' + '                    data-toggle="dropdown" aria-label="company name ending" aria-expanded="false">' + '                LTD' + '            </button>' + '            <div class="dropdown-menu">' + '                <a tabindex="-1" href="#" class="dropdown-item text-sm name-ending" data-value="LTD" style="cursor: pointer;"' + '                   aria-label="LTD">LTD' + '                </a>' + '                <a tabindex="-1" href="#" class="dropdown-item text-sm name-ending" data-value="Limited" style="cursor: pointer;"' + '                   aria-label="Limited">Limited' + '                </a>' + '            </div>' + '        </div>' + '    </div>' + '    </div>' + '    <div style="display: flex;justify-content: flex-end;" class="mt-5">' + '       <button ' + dataRedirect + ' type="submit" class="btn btn-lg btn-success text-md btn-narrow">Get Started</button>' + '    </div>' + '</form>');
    var bind = function bind() {
      $(document).on('submit', '.form-ch-search-custom', function () {
        LSCMSUtils.onSearchFormCTAClick($(this));
        return false;
      });
      $('input[type="text"]', $modal).keyup(function (e) {
        var code = e.key;
        if (code === 'Enter') {
          e.preventDefault();
          LSCMSUtils.onSearchFormCTAClick($(this).closest('form'));
          return false;
        }
      });
      $('a.name-ending', $modal).click(function () {
        $('button.name-ending-selected').html($(this).attr('data-value'));
        $('.dropdown-menu.show').removeClass('show');
        return false;
      });
    };
    bind();
    this.popup = BootstrapDialog.show({
      title: 'Alert',
      closable: true,
      message: $modal
    });
  },
  onSearchFormCTAClick: function onSearchFormCTAClick($form) {
    var _$$attr;
    var companyNameOrNumber = encodeURIComponent($('input', $form).val());
    var dataRedirect = (_$$attr = $('[type="submit"]', $form).attr('data-redirect')) !== null && _$$attr !== void 0 ? _$$attr : '/company/search/';
    var redirectUrl = LSUtils.url() + dataRedirect + '?company=' + companyNameOrNumber;
    $form.addClass('was-validated');
    if ($form[0].checkValidity()) {
      var btn = Ladda.create($('button', $form)[0]);
      btn.start();
      var data = {
        'emails.ltdEnding': $('button.dropdown-toggle').text().replaceAll('\n', '').trim()
      };
      LSCMSUtils.savePreCheckoutData(data).done(function () {
        window.location.href = redirectUrl;
        btn.stop();
      });
    }
  },
  // PENDING ORDER

  shouldShowPendingOrder: function shouldShowPendingOrder() {
    var _clientData$orderData;
    if (this.pendingOrderPages.includes(clientData.page.type)) return (_clientData$orderData = clientData.orderData) === null || _clientData$orderData === void 0 ? void 0 : _clientData$orderData.paymentKey;
    return false;
  },
  showPendingOrder: function showPendingOrder() {
    var $content = $('<div class="container">' + '   <div class="row">' + '       <div class="col-sm-2 hidden-xs">' + '           <i class="fa fa-question-circle title-lg bold"></i>' + '       </div>' + '       <div class="col-sm-10">' + '           It seems you already have a pending order...<br />' + '           <br />' + '           What would you like to do?<br /><br />' + '       </div>' + '   </div>' + '</div>');
    this.popup = BootstrapDialog.show({
      title: 'Alert',
      closable: false,
      message: $content,
      buttons: [{
        id: 'button-new-order',
        label: 'Start new',
        cssClass: 'btn btn-primary ladda-button',
        data: {
          style: 'expand-right'
        },
        action: function action() {
          var crtUrl = window.location.href;
          if (crtUrl.includes('?')) window.location.href = window.location.href + '&new';else window.location.href = window.location.href + '?new';
          return false;
        }
      }, {
        id: 'button-goto-dashboard',
        label: 'Go to dashboard',
        cssClass: 'btn btn-success ladda-button',
        data: {
          style: 'expand-right'
        },
        action: function action() {
          window.location.href = LSUtils.url() + '/status/?clientId=' + clientData.clientId;
          return false;
        }
      }]
    });
  },
  // ZENDESK

  shouldPreOpenZendeskWidget: function shouldPreOpenZendeskWidget() {
    var zendeskQs = LSUtils.getQueryStringParameter('zendesk');
    return zendeskQs && zendeskQs === 'chat';
  },
  preOpenZendeskWidget: function preOpenZendeskWidget() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
    setTimeout(function () {
      try {
        if (zEmbed && typeof zEmbed.activate === 'function') {
          var searchStrings = new URLSearchParams(window.location.search);
          if (searchStrings.get("name") && searchStrings.get("email")) {
            zEmbed.identify({
              name: searchStrings.get("name"),
              email: searchStrings.get("email"),
              message: searchStrings.get("msg")
            });
          }
          zEmbed.activate();
        }
      } catch (ex) {
        console.log('zendesk chat activation failed');
      }
    }, delay);
  },
  // CONFETTI
  confetti: function confetti() {
    if (!$('canvas').length) $('body').append('<canvas id="canvas" style="pointer-events:none;position: fixed;top:0;left:0;width:100%;height:100%;z-index:999"></canvas>');
    var W = window.innerWidth;
    var H = window.innerHeight;
    var canvas = document.getElementById("canvas");
    var context = canvas.getContext("2d");
    var maxConfettis = 150;
    var particles = [];
    var possibleColors = ["DarkYellow", "LightRed", "PaleGreen", "Green", "#28a745", "#d4edda", "LightBlue"];
    function randomFromTo(from, to) {
      return Math.floor(Math.random() * (to - from + 1) + from);
    }
    function confettiParticle() {
      this.x = Math.random() * W; // x
      this.y = Math.random() * H - H; // y
      this.r = randomFromTo(11, 33); // radius
      this.d = Math.random() * maxConfettis + 11;
      this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
      this.tilt = Math.floor(Math.random() * 33) - 11;
      this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
      this.tiltAngle = 0;
      this.draw = function () {
        context.beginPath();
        context.lineWidth = this.r / 2;
        context.strokeStyle = this.color;
        context.moveTo(this.x + this.tilt + this.r / 3, this.y);
        context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
        return context.stroke();
      };
    }
    function Draw() {
      var results = [];

      // Magical recursive functional love
      requestAnimationFrame(Draw);
      context.clearRect(0, 0, W, window.innerHeight);
      for (var _i = 0; _i < maxConfettis; _i++) results.push(particles[_i].draw());
      var particle = {};
      for (var _i2 = 0; _i2 < maxConfettis; _i2++) {
        particle = particles[_i2];
        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2;
        particle.tilt = Math.sin(particle.tiltAngle - _i2 / 3) * 15;
      }
      return results;
    }
    window.addEventListener("resize", function () {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }, false);

    // Push new confetti objects to `particles[]`

    for (var i = 0; i < maxConfettis; i++) {
      particles.push(new confettiParticle());
    }

    // Initialize
    canvas.width = W;
    canvas.height = H;
    Draw();
  },
  // HELPERS

  initPopovers: function initPopovers() {
    // init popovers...
    var isShowing = false;
    var $popovers = $('[data-toggle="popover"]');
    if (typeof $popovers.popover == 'function') {
      $popovers.popover({
        trigger: 'focus',
        html: true
      });
      $popovers.bind('click', function (event) {
        $popovers.popover('hide');
        isShowing = false;
        $(this).popover('toggle');
        isShowing = true;
        event.stopPropagation();
      });
      $('body').bind('click', function () {
        if (isShowing) $popovers.popover('hide');
        isShowing = false;
      });
    }
  },
  isEECommerceEnabled: function isEECommerceEnabled() {
    return false;
  },
  getLocationClean: function getLocationClean() {
    var location = window.location.pathname;
    if (location.split("").pop() === '/') {
      location = location.slice(0, -1);
    }
    return location;
  },
  loadGtm: function loadGtm() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('consent', 'default', {
      'ad_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'analytics_storage': 'granted'
    });
    if (!LSUtils.isDebug() || LSUtils.getQueryStringParameter('gtm') === 'true') {
      setTimeout(function () {
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-N264FM3');
      }, 1000);
    }
  },
  gtmPageViewEvent: function gtmPageViewEvent(pagePath) {
    pagePath = pagePath.replaceAll('//', '/');
    var utms = [];
    var utm_source = LSUtils.getQueryStringParameter('utm_source');
    var utm_campaign = LSUtils.getQueryStringParameter('utm_campaign');
    var utm_medium = LSUtils.getQueryStringParameter('utm_medium');
    var gclid = LSUtils.getQueryStringParameter('gclid');
    var msclkid = LSUtils.getQueryStringParameter('msclkid');
    if (utm_source) utms.push('utm_source=' + utm_source);
    if (utm_campaign) utms.push('utm_campaign=' + utm_campaign);
    if (utm_medium) utms.push('utm_medium=' + utm_medium);
    if (gclid) utms.push('gclid=' + gclid);
    if (msclkid) utms.push('msclkid=' + msclkid);
    var pageLocation = pagePath + (utms.length ? '?' + utms.join('&') : '');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": 'page_view',
      "page_location": pageLocation,
      "page_title": pagePath
    });
  },
  gtmPurchaseEvent: function gtmPurchaseEvent(order) {
    var _clientData, _clientData2, _clientData3, _clientData4, _clientData5, _clientData6, _clientData7, _clientData8, _clientData9;
    var value = (_clientData = clientData) !== null && _clientData !== void 0 && (_clientData = _clientData.sjData) !== null && _clientData !== void 0 && (_clientData = _clientData.topLevelService) !== null && _clientData !== void 0 && _clientData.withoutVat ? (_clientData2 = clientData) === null || _clientData2 === void 0 || (_clientData2 = _clientData2.sjData) === null || _clientData2 === void 0 || (_clientData2 = _clientData2.topLevelService) === null || _clientData2 === void 0 ? void 0 : _clientData2.withoutVat : clientData.orderData.subTotal;
    var pkg = (_clientData3 = clientData) !== null && _clientData3 !== void 0 && (_clientData3 = _clientData3.orderData) !== null && _clientData3 !== void 0 && _clientData3.package && (_clientData4 = clientData) !== null && _clientData4 !== void 0 && (_clientData4 = _clientData4.orderData) !== null && _clientData4 !== void 0 && (_clientData4 = _clientData4.package) !== null && _clientData4 !== void 0 && _clientData4.id ? '/pkg/' + ((_clientData5 = clientData) === null || _clientData5 === void 0 || (_clientData5 = _clientData5.orderData) === null || _clientData5 === void 0 || (_clientData5 = _clientData5.package) === null || _clientData5 === void 0 ? void 0 : _clientData5.id) : '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "purchase",
      "ecommerce": {
        "transaction_id": clientData.orderData.paymentKey,
        "currency": "GBP",
        "value": value,
        "items": [{
          "item_id": clientData.product.path + pkg,
          "item_name": clientData.product.path + pkg,
          "price": value
        }]
      },
      "enhanced_conversion_data": {
        "email": (_clientData6 = clientData) === null || _clientData6 === void 0 || (_clientData6 = _clientData6.customerData) === null || _clientData6 === void 0 || (_clientData6 = _clientData6.personalInfo) === null || _clientData6 === void 0 ? void 0 : _clientData6.email,
        "address": {
          "first_name": (_clientData7 = clientData) === null || _clientData7 === void 0 || (_clientData7 = _clientData7.customerData) === null || _clientData7 === void 0 || (_clientData7 = _clientData7.personalInfo) === null || _clientData7 === void 0 ? void 0 : _clientData7.firstName,
          "last_name": (_clientData8 = clientData) === null || _clientData8 === void 0 || (_clientData8 = _clientData8.customerData) === null || _clientData8 === void 0 || (_clientData8 = _clientData8.personalInfo) === null || _clientData8 === void 0 ? void 0 : _clientData8.lastName,
          "postal_code": (_clientData9 = clientData) === null || _clientData9 === void 0 || (_clientData9 = _clientData9.customerData) === null || _clientData9 === void 0 || (_clientData9 = _clientData9.personalInfo) === null || _clientData9 === void 0 ? void 0 : _clientData9.zip,
          "country": "UK"
        }
      }
    });
  }
};
$(function () {
  LSCMSUtils.initialize();
});
export { LSCMSUtils };